// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"0c0e889b","650":"9eee1eaa","665":"378cb906","764":"9af2e614","787":"d5fa4d18","951":"b4571c60"}[chunkId] + ".chunk.js";
};